import React from 'react';
import { CheckCircle } from 'lucide-react';

/**
 * Step progress rail shared by Business Grant and Service proposal wizards.
 * Matches the indicator in ProposalWizardPage.jsx (numbered labels + icon circles).
 */
export function ProposalStepIndicator({ steps, step }) {
  return (
    <div className="flex items-center justify-between gap-2 overflow-x-auto pb-2" data-testid="step-indicator">
      {steps.map((s, idx) => {
        const Icon = s.icon;
        const done = step > s.id;
        const current = step === s.id;
        return (
          <div key={s.id} className="flex items-center min-w-0 shrink-0">
            <div className={[
              "flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold shrink-0",
              done ? "bg-primary text-primary-foreground" : current ? "bg-primary/15 text-primary ring-2 ring-primary" : "bg-muted text-muted-foreground",
            ].join(' ')}>
              {done ? <CheckCircle className="h-4 w-4" /> : <Icon className="h-4 w-4" />}
            </div>
            <div className="ml-2 hidden sm:block min-w-0">
              <div className={["text-xs font-medium", current ? "text-primary" : "text-foreground"].join(' ')}>{s.id}. {s.title}</div>
              <div className="text-[10px] text-muted-foreground truncate">{s.hint}</div>
            </div>
            {idx < steps.length - 1 && <div className="mx-2 h-px w-6 sm:w-10 bg-border shrink-0" />}
          </div>
        );
      })}
    </div>
  );
}
